/* unplugin-vue-components disabled */import { render } from "./member_userCard_xq_m.vue?vue&type=template&id=5c6a9c1b&scoped=true"
import script from "./member_userCard_xq_m.vue?vue&type=script&lang=js"
export * from "./member_userCard_xq_m.vue?vue&type=script&lang=js"

import "./member_userCard_xq_m.vue?vue&type=style&index=0&id=5c6a9c1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6a9c1b"]])

export default __exports__